import type { IGetKeyIndicatorsType } from '@/types/dashboard.types';

import axiosWrapper from '@mylight150/axios-wrapper';

export const getKeyIndicators = async (companyId: string): Promise<IGetKeyIndicatorsType> => {
  try {
    const response = await axiosWrapper.get(
      `/pro-installation/companies/${companyId}/premium-partners/key-indicators`
    );
    return response.data;
  } catch {
    throw new Error();
  }
};
